module.exports = __webpack_public_path__ + "img/totalRegistersPlus.cd795dd5.svg";